import APICaller from "@/library/APICaller";

// Controller 이름
const DashboardServices = {
  /**
   * @param  {String} params.empNo
   * @param  {String} params.startMonth 시작월
   * @param  {String} params.endMonth 종료월
   * @return {Promise}
   */
  getBillChartData ({ empNo, startMonth, endMonth, customerDepts }) {
    return APICaller.post('/api/v1/dashboard/bill-chart', { empNo, startMonth, endMonth, customerDepts })
  },
  getProductChartData ({ empNo, startMonth, endMonth, customerDepts }) {
    return APICaller.post('/api/v1/dashboard/products-chart', { empNo, startMonth, endMonth, customerDepts })
  },
  getBeforeMonthUsedAmount ({ empNo, customerDepts }) {
    return APICaller.post('/api/v1/dashboard/before-month-total-used-amount', { empNo, customerDepts })
  },
  selectBeforeMonthContractTop ({ empNo, customerDepts }) {
    return APICaller.post('/api/v1/dashboard/before-month-contact-top', { empNo, customerDepts })
  },
  selectBeforeMonthProductsTop ({ empNo, customerDepts }) {
    return APICaller.post('/api/v1/dashboard/before-month-products-top', { empNo, customerDepts })
  },

  getServiceRequestSatus ({ empNo, startDate, endDate, customerDepts }) {
    return APICaller.post('/api/v1/servicereqeusts/status', { empNo, startDate, endDate, customerDepts })
  },
  getNotices ({ pageNo, size, searchText }) {
    return APICaller.get('/api/v1/dashboard/notices', {
      'pagingDTO.pageNo': pageNo,
      'pagingDTO.size': size,
      searchText: searchText
    })
  },
}

export default DashboardServices



// WEBPACK FOOTER //
// ./src/services/DashboardServices.js